/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBatchControlLookup.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/batch-control-lookup";

export class AutogenModelBatchControlLookup<RowType extends ModelRow> extends Endpoint<RowType, RowBatchControlLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBatchControlLookup extends ModelRow<RowBatchControlLookupFields> {
	constructor(values?: Partial<RowBatchControlLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBatchControlLookupFields {
	ap: string;
	cash: string;
	code: string;
	company_id: string;
	descr: string;
	driver: string;
	fuel: string;
	is_intercompany: string;
	next_batch_no: number;
	office: string;
	program: string;
	sales: string;
	vm: string;
}

